import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button as ButtonBS } from "react-bootstrap";
import { cl } from "../../../../utilities/cl";
import {
  update,
  createAdsExtra,
} from "../../../../store/Modal/types/AdsCreate/actions";
import { loadVideolists } from "../../../../store/ContentVideolists/actions";

import Header from "../../components/header";
import Builder from "../../../Settings/Builder";
import fieldStarttime from "../../..//Settings/sets/ObjectBackground/items/starttime";
import { setsex } from "../../../Settings/utilities/setsclasses";
import { updateHelper } from "../../../Settings/utilities/updateHelper";
import { carryUpdate } from "../../../Settings/utilities/carryUpdate";
import { OBJECT_BACKGROUND } from "../../../../store/Settings/sets";
import { generateStateKey } from "../../../../utilities/generateStateKey";

import GroupDays from "../../../Settings/sets/ObjectBackground/groups/Days";

import { updateOptions } from "../../../../store/Settings/actions";
import { saveItems } from "../../../../store/Settings/actions/sets/Object/Background";
import { closeModal } from "../../../../store/Modal/actions";

const ObjectBackgroundEditing = (props) => {
  const [list, setList] = useState([]);
  const [filename, setFilename] = useState(false);
  const [name, setName] = useState(false);
  const [videolist_id, setVideolistId] = useState(false);
  const [description, setDescription] = useState(false);
  const [sumbitDisabled, setSubmitDisabled] = useState(true);
  const [track, setTrack] = useState({
    name: "—",
    size: "—",
    duration: "—",
  });

  const { store, stateKey, selected, updateOptions, toggleOpened, loading } =
    props;
  console.log("ObjectBackgroundEditing", {
    store,
    stateKey,
    selected,
    updateOptions,
    toggleOpened,
    loading,
  });

  // --- Настройки для выбранного item ---
  const itemStateKey = generateStateKey([stateKey, selected[0]]);
  const itemSettings = store[itemStateKey] || {};

  const updateOptionsItem = carryUpdate({
    type: OBJECT_BACKGROUND,
    stateKey: itemStateKey,
    updateOptions,
  });

  const hChangeItem = (name) =>
    updateHelper({
      name,
      updateOptions: updateOptionsItem,
    });

  useEffect(() => {
    props.update();
    props.loadVideolists();
  }, []);

  const hSaveItems = () => {
    props.saveItems({ stateKey });

    toggleOpened();
  };

  const hSubmit = () => {
    if (list.length <= 1) {
      props.createAdsExtra({
        filename,
        name,
        videolist_id,
        description: description || "",
      });
    } else {
      props.createAdsExtra({
        list,
        videolist_id,
        setVal,
      });
    }
  };

  const setVal = (index, attr, val) => {
    setList((prev) => {
      const copy = [...prev];
      copy[index][attr] = val;
      return copy;
    });
  };

  const validateForm = () => {
    if (
      (filename && typeof name === "string" && name.length > 1) ||
      list.length >= 2
    ) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  };

  // --- Остальная логика загрузки и обработки файлов можно вынести сюда ---
  // hLoadfile, hInputText, convertFile, updateList — по аналогии с классом

  return (
    <div className="ModalAdsCreate">
      <Header
        title="Редактирование временного диапазона проигрывания"
        toggleOpened={toggleOpened}
      />

      <div className="ModalCastinfo__content">
        <Builder
          className={"SettingsObjectBackground"}
          groups={{
            all: [
              {
                data: {
                  columns: 2,
                  noDivider: true,
                  className: setsex(["col-2", "mr"]),
                },
                items: [
                  {
                    title: "Время начала",
                    components: fieldStarttime({
                      settings: itemSettings,
                      name: "starttime",
                      onChange: hChangeItem("starttime"),
                    }),
                  },
                ],
              },
              <GroupDays
                className={setsex(["col-1"])}
                value={itemSettings["daymask"]}
                onChange={hChangeItem("daymask")}
                disabled={!selected.length}
              />,
            ],
          }}
        />
      </div>

      <div className="Modal__footer">
        <ButtonBS onClick={hSaveItems} variant="primary">
          {loading ? "Сохранение..." : "Сохранить"}
        </ButtonBS>
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  store: state.settings.settings[OBJECT_BACKGROUND],
  loading: state.modalAdsCreate.loading,
  allVideolists: [
    { title: "Не привязывать", value: 0 },
    ...state.videolists.allVideolists.map((vl) => ({
      title: vl.name,
      value: vl.id,
      subtitle: `${vl.totalcount} шт (${vl.totalsize})`,
    })),
  ],
});

export default connect(stateToProps, {
  update,
  createAdsExtra,
  loadVideolists,
  saveItems,
  updateOptions,
})(ObjectBackgroundEditing);
